import { Injectable } from '@angular/core';

/**
 * HV-05: tracks whether a mutating (write) HTTP request has completed since the
 * subtab GetRecord short-circuit last fetched a record. `LoadingHttpInterceptor`
 * flags this on a successful /write or /multiwrite response; the record-details
 * resolvers (`UpdateEntityParamsResolver`) check it before skipping GetRecord on a
 * plain subtab navigation, and reset it after a successful GetRecord only if no
 * newer write completed while the fetch was in flight, so a
 * save made in one subtab (stacking-plan floor, availability, multiwrite, ...) is
 * never masked by a stale cached header on the next subtab click.
 */
@Injectable({ providedIn: 'root' })
export class RecordWriteTrackerService {
  #dirty = false;
  #revision = 0;

  markWritten(): void {
    this.#dirty = true;
    this.#revision++;
  }

  get revision(): number {
    return this.#revision;
  }

  /** True when a write has completed since the last reset(). */
  get dirty(): boolean {
    return this.#dirty;
  }

  /** Clear writes covered by the fetch, preserving any that completed after it started. */
  reset(revision = this.#revision): void {
    if (revision === this.#revision) {
      this.#dirty = false;
    }
  }
}
